import * as t from 'io-ts';
import { fromEnum } from '../../responseUtil';
import { ApiServiceType } from './serviceTypesApi.types';
import { ApiServiceOrderStatus } from './serviceOrdersApi.types';

export enum ServiceOrderApiSort {
    STATUS_ASC = '+status',
    STATUS_DES = '-status',
    STARTED_AT_DESC = '-started_at',
    STARTED_AT_ASC = '+started_at',
    COMPLETED_AT_DESC = '-completed_at',
    COMPLETED_AT_ASC = '+completed_at',
    TYPE_ASC = '+type',
    TYPE_DESC = '-type',
    ORDER_ISSUED_AT_ASC = '+order_issued_at',
    ORDER_ISSUED_AT_DESC = '-order_issued_at',
    LOCATION_IDENTIFIER_ASC = '+location_identifier',
    LOCATION_IDENTIFIER_DESC = '-location_identifier',
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const ServiceOrderQueryParameterCodec = t.partial({
    service_location: t.string,
    service_types: t.array(fromEnum<ApiServiceType>('ApiServiceType', ApiServiceType)),
    statuses: t.array(fromEnum<ApiServiceOrderStatus>('ApiServiceOrderStatus', ApiServiceOrderStatus)),
    order_issued_at_after: t.string,
    order_issued_at_before: t.string,
    archived: t.boolean,
    q: t.string,
    sort: fromEnum<ServiceOrderApiSort>('ServiceOrderApiSort', ServiceOrderApiSort),
    limit: t.number,
});

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const ServiceOrderExcelQueryParameterCodec = t.partial({
    service_location: t.string,
    statuses: t.array(fromEnum<ApiServiceOrderStatus>('ApiServiceOrderStatus', ApiServiceOrderStatus)),
    service_types: t.array(fromEnum<ApiServiceType>('ApiServiceType', ApiServiceType)),
    order_issued_at_after: t.string,
    order_issued_at_before: t.string,
});
export type ApiServiceOrderQueryParameter = t.TypeOf<typeof ServiceOrderQueryParameterCodec>;
export type ApiServiceOrderExcelQueryParameter = t.TypeOf<typeof ServiceOrderExcelQueryParameterCodec>;
